/*
Copyright (c) 2022 - https://codepen.io/jeffsmith/pen/mPByya/

Permission is hereby granted, free of charge, to any person
obtaining a copy of this software and associated documentation
files (the "Software"), to deal in the Software without restriction,
 including without limitation the rights to use, copy, modify,
merge, publish, distribute, sublicense, and/or sell copies of
the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall
be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
DEALINGS IN THE SOFTWARE.

*/

(function ($) {
    function isRoving(el) {
        return $(el).closest('.js-tabs').hasClass('js-tabs--roving');
    }

    function tabInit() {
        const tabs = $('.js-tabs');

        const tabSliderOptions = {
            slidesToShow: 1,
            infinite: false,
            adaptiveHeight: false,
            prevArrow: $('.team-slider').parent().find('.slick-prev'),
            nextArrow: $('.team-slider').parent().find('.slick-next'),
        };

        let increment = 0;
        $('ul.js-tabs-list a').each(function () {
            increment++;
            const newLink = `#tab-${increment}`;
            $(this).attr('href', newLink);
        });

        // For each individual tab DIV, set class and aria-hidden attribute, and hide it
        $(tabs)
            .find('> div')
            .attr({
                class: 'js-tab-panel',
                'aria-hidden': 'true',
            })
            .hide();

        // Get the list of tab links
        const tabsList = tabs.find('ul.js-tabs-list');

        // For each item in the tabs list...
        $(tabsList)
            .find('li > a')
            .each(function (a) {
                const tab = $(this);

                // Create a unique id using the tab link's href
                const tabClass = `${tab.attr('href').slice(1)}`;

                // Assign tab id and aria-selected attribute to the tab control, but do not remove the href
                tab
                    .attr({
                        'aria-selected': 'false',
                    })
                    .parent()
                    .attr('role', 'presentation');

                if (isRoving(tab)) {
                    tab.attr('tabindex', tab.parent().is(':first-child') ? '0' : '-1');
                }

                tab.addClass(tabClass);
                // Assign aria attribute to the relevant tab panel
                if (!isRoving(tab)) {
                    $(tabs).find('.js-tab-panel').eq(a).attr('aria-labelledby', tabClass);
                }

                // Set the click event for each tab link
                tab.click(function (e) {
                    let tabPanel;

                    // Prevent default click event
                    e.preventDefault();

                    const roving = isRoving(this);

                    // Change state of previously selected tabList item
                    const previous = $(this)
                        .parents('.js-tabs-list')
                        .find('a.current')
                        .removeClass('current')
                        .attr('aria-selected', 'false');

                    if (roving) {
                        previous.attr('tabindex', '-1');
                    }

                    // Hide previously selected tabPanel
                    $(this)
                        .parents('.js-tabs')
                        .find('.js-tab-panel:visible')
                        .attr('aria-hidden', 'true')
                        .hide();

                    // Show newly selected tabPanel
                    tabPanel = $(this).parents('.js-tabs').find('.js-tab-panel').eq(tab.parent().index());
                    tabPanel.attr('aria-hidden', 'false').show();

                    // Set state of newly selected tab list item
                    tab.attr('aria-selected', 'true').addClass('current');

                    if (roving) {
                        tab.attr('tabindex', '0');
                    }

                    // Scroll the tabpanel into view on click if for Appointment Tabs
                    if (tab.hasClass('appointments__tabs-link')) {
                        $('html, body').animate({
                            scrollTop: tabPanel.offset().top - 75
                        }, 400);
                    }

                    // Set focus to the first heading in the newly revealed tab content
                    if (!roving) {
                        tabPanel.find('input').attr('tabindex', -1).focus();
                    }

                    // ReInit team slider if present
                    if ($(`#${tabClass} .team-slider`).hasClass('slick-initialized')) {
                        $(`#${tabClass} .team-slider`).slick('unslick').slick(tabSliderOptions);
                    } else {
                        $(`#${tabClass} .team-slider`).slick(tabSliderOptions);
                    }

                    // Hide team slider controls when filters and arrows aren't needed
                    if ($(`#${tabClass} .slick-arrow`).hasClass('slick-hidden') && !$(`#${tabClass} .team-cards__slider-form`).length) {
                        $(`#${tabClass}`).find('.team-cards__slider-controls').addClass('controls-hidden');
                    }
                });
            });

        // Set keydown events on tabList item for navigating tabs
        $(tabsList).delegate('a', 'keydown', function (e) {
            const tab = $(this);

            if (isRoving(this)) {
                const list = tab.closest('.js-tabs-list');
                let target;

                switch (e.which) {
                    case 37:
                    case 38:
                        target = tab.parent().prev().length
                            ? tab.parent().prev().find('> a')
                            : list.find('li:last-child > a');
                        break;
                    case 39:
                    case 40:
                        target = tab.parent().next().length
                            ? tab.parent().next().find('> a')
                            : list.find('li:first-child > a');
                        break;
                    case 36:
                        target = list.find('li:first-child > a');
                        break;
                    case 35:
                        target = list.find('li:last-child > a');
                        break;
                    default:
                        return;
                }

                e.preventDefault();
                target.focus().click();
                return;
            }

            switch (e.which) {
                case 37:
                case 38:
                    if (tab.parent().prev().length != 0) {
                        tab.parent().prev().find('> a').click();
                    } else {
                        $(tabsList).find('li:last > a').click();
                    }
                    break;
                case 39:
                case 40:
                    if (tab.parent().next().length != 0) {
                        tab.parent().next().find('> a').click();
                    } else {
                        $(tabsList).find('li:first > a').click();
                    }
                    break;
            }
        });
    // Show the first tabPanel
    if (!$('.js-tabs').hasClass('js-tabs--closed')) {
      $(tabs).find('.js-tab-panel:first').attr('aria-hidden', 'false').show();

      // Set state for the first tabsList li
      $(tabsList).find('li:first a').addClass('current').attr({
        'aria-selected': 'true',
        tabindex: '0',
      });

      // Init team slider if present
      if($('#tab-1 .team-slider') && !$('#tab-1 .team-slider').hasClass('slick-initialized')) {
        $('#tab-1 .team-slider').slick(tabSliderOptions);
      }

      // Hide team slider controls when filters and arrows aren't needed
      if ($('#tab-1 .slick-arrow').hasClass('slick-hidden') && !$('#tab-1 .team-cards__slider-form').length) {
        $('#tab-1').find('.team-cards__slider-controls').addClass('controls-hidden');
      }
    }

    $('.js-tabs--roving').not('.js-tabs--closed').each(function () {
      const group = $(this);

      group.find('.js-tab-panel').first().attr('aria-hidden', 'false').show();

      group.find('.js-tabs-list li:first-child > a').addClass('current').attr({
        'aria-selected': 'true',
        tabindex: '0',
      });
    });
  }

  // Make tabInit accessible globally
  window.tabInit = tabInit;

  // Execute tabInit on load
  $(window).on('load', tabInit);
}(jQuery));
